/*
 * ELASTICSEARCH CONFIDENTIAL
 * __________________
 *
 *  Copyright Elasticsearch B.V. All rights reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Elasticsearch B.V. and its suppliers, if any.
 * The intellectual and technical concepts contained herein
 * are proprietary to Elasticsearch B.V. and its suppliers and
 * may be covered by U.S. and Foreign Patents, patents in
 * process, and are protected by trade secret or copyright
 * law.  Dissemination of this information or reproduction of
 * this material is strictly forbidden unless prior written
 * permission is obtained from Elasticsearch B.V.
 */

import type { RoleBadgesModule } from '../types'

const cloudConnectedRoleBadgesModule: RoleBadgesModule<'cloud-connected'> = {
  allInstancesRoleBadgeTooltipMessages: {
    id: 'role-badges.tooltip.all-cloud-connected',
    defaultMessage: 'This role applies to all current and future cloud connected clusters.',
  },
  specificInstancesRoleBadgeTooltipMessages: {
    id: 'role-badges.tooltip.cloud-connected',
    defaultMessage:
      'This role applies to {count} cloud connected {count, plural, one {cluster} other {clusters}}.',
  },
  customRoleBadgeTooltipMessages: {
    id: 'custom-role-badges.tooltip.cloud-connected',
    defaultMessage:
      'This role applies to {count} cloud connected {count, plural, one {cluster} other {clusters}}.',
  },
  type: 'cloud-connected',
}

export default cloudConnectedRoleBadgesModule
